(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var form = document.querySelector('[data-coupon-form]');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('[data-coupon-input]');
    var msg = form.querySelector('[data-coupon-msg]');
    var code = (input.value || '').trim();
    if (!code) {
      if (msg) { msg.hidden = false; msg.textContent = input.getAttribute('data-empty') || 'Enter a code.'; }
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });
})();

  } catch(e) { console.error(e); }
})();
})();
